/** @jsx jsx */
import { useState, useRef, useEffect } from "react"
import { jsx, Flex, Button, Text, Box } from "theme-ui"
import styled from "@emotion/styled"
import Icon from "./Icon"
import Action from "./Action"
import SecondaryDropdown from "./SecondaryDropdown"

const DropdownContainer = styled.div`
  .menu-trigger {
    cursor: pointer;
    margin: 0;
    padding: 0;
  }

  .menu {
    background: ${(t) => t.theme.colors.white};
    border-radius: 10px;
    position: absolute;
    width: inherit;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-20px);
    transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
    z-index: 99;
  }

  .menu.active {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    box-shadow: 0px 10px 50px #00000041;
  }

  .menu ul {
    padding: 0;
  }
`

const DropdownMenu = ({ links, isActive, setActiveDropdown }) => {
  const dropdownRef = useRef(null)
  const onClick = (e) => {
    e.stopPropagation()
    setActiveDropdown(isActive ? null : links.id)
  }
  const dropdownLinks = links.links

  useEffect(() => {
    const pageClickEvent = (e) => {
      if (dropdownRef.current !== null && !dropdownRef.current.contains(e.target)) {
        setActiveDropdown(null)
      }
    }

    if (isActive) {
      window.addEventListener("click", pageClickEvent)
    }

    return () => {
      window.removeEventListener("click", pageClickEvent)
    }
  }, [isActive, setActiveDropdown])

  return (
    <DropdownContainer role="button" tabIndex="0" aria-expanded={isActive}>
      <Flex
        as="div"
        className="menu-trigger"
        sx={{
          variant: "navLink",
          alignItems: "center",
        }}
      >
        <Button
          aria-expanded={isActive}
          onClick={onClick}
          sx={{
            border: "none",
            background: "none",
            fontSize: "inherit",
            margin: 0,
            padding: 0,
            variant: "navLink",
          }}
        >
          {/* <Icon icon="heart" sx={{ marginRight: '4px' }} /> */}
          <Text sx={{ color: isActive && "orangeV2", fontSize: "14px" }}>{links.dropdownTitle.toUpperCase()}</Text>
          <Icon
            icon="down-chevron"
            sx={{
              marginLeft: "4px",
              transform: isActive && "rotate(180deg)",
              flexShrink: 0,
              minWidth: "14px",
              minHeight: "14px",
            }}
            color={isActive && "#FF6310"}
          />
        </Button>
      </Flex>
      <span ref={dropdownRef} aria-expanded={isActive} className={`menu ${isActive ? "active" : "inactive"}`}>
        <ul>
          {dropdownLinks.map((link) =>
            link.__typename === "ContentfulNavDropdown" && link.dropdownMainLink ? (
              <Box as="li" key={link.id} sx={{ variant: "navListItem" }}>
                <SecondaryDropdown key={link.id} dropdown={link} />
              </Box>
            ) : (
              <li
                key={link.id}
                sx={{
                  variant: "navListItem",
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                className="main_nav_action_btn"
              >
                <Action
                  onFinish={() => setActiveDropdown(null)}
                  key={link.id}
                  {...link}
                  fontColor="#272763"
                  iconColor="#272763"
                  width="100%"
                  fontsize="14px"
                  backgroundColorForText="#ffcbaf"
                  classnameForAnalytics={link.classnameForAnalytics}
                />
                <Box sx={{ textAlign: "center" }}>
                  {/* <BsArrowRightShort className="secondary_icon" size={18} /> */}
                </Box>
              </li>
            ),
          )}
        </ul>
      </span>
    </DropdownContainer>
  )
}

export default DropdownMenu
